import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { getMonthOptions, getYearOptions } from "./pnlReportUtils";

const toOption = (value) => ({ value, label: value });

const MultiFilter = ({ id, label, options, selected, placeholder, onChange }) => (
  <div className="pnl-field">
    <label htmlFor={id}>{label}</label>
    <Select
      inputId={id}
      isMulti
      closeMenuOnSelect={false}
      options={options}
      value={selected}
      onChange={(chosen) => onChange(chosen.map((option) => option.value))}
      classNamePrefix="pnl-select"
      placeholder={placeholder}
    />
  </div>
);

const optionShape = PropTypes.shape({ value: PropTypes.string, label: PropTypes.string });

MultiFilter.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(optionShape).isRequired,
  selected: PropTypes.arrayOf(optionShape).isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const PnLFilters = ({
  filters,
  categoryOptions,
  typeOptions,
  errorMessage,
  disabled,
  onChange,
  onApply,
  onClear,
}) => {
  const handleChange = (field) => (event) => onChange(field, event.target.value);
  const monthOptions = getMonthOptions(filters.year);
  const selectedCategories = categoryOptions.filter((option) => filters.categories.includes(option.value));

  return (
    <div className="pnl-filters">
      <div className="pnl-field">
        <label htmlFor="pnl-year">Year</label>
        <select id="pnl-year" value={filters.year} onChange={handleChange("year")}>
          {getYearOptions().map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>
      <div className="pnl-field">
        <label htmlFor="pnl-from">From month</label>
        <select id="pnl-from" value={filters.fromMonth} onChange={handleChange("fromMonth")}>
          {monthOptions.map((month) => (
            <option key={month.value} value={month.value}>{month.label}</option>
          ))}
        </select>
      </div>
      <div className="pnl-field">
        <label htmlFor="pnl-to">To month</label>
        <select
          id="pnl-to"
          value={filters.toMonth}
          onChange={handleChange("toMonth")}
          aria-invalid={Boolean(errorMessage)}
          aria-describedby={errorMessage ? "pnl-filter-error" : undefined}
        >
          {monthOptions.map((month) => (
            <option key={month.value} value={month.value}>{month.label}</option>
          ))}
        </select>
        {errorMessage && <div id="pnl-filter-error" className="pnl-filter-error" role="alert">{errorMessage}</div>}
      </div>
      <MultiFilter
        id="pnl-category"
        label="Category"
        options={categoryOptions}
        selected={selectedCategories}
        placeholder="All categories"
        onChange={(values) => onChange("categories", values)}
      />
      <MultiFilter
        id="pnl-type"
        label="Type"
        options={typeOptions.map(toOption)}
        selected={filters.subTypes.map(toOption)}
        placeholder="All types"
        onChange={(values) => onChange("subTypes", values)}
      />
      <div className="pnl-filter-buttons">
        <button type="button" className="btn cus-seconday-bg-btn" onClick={onApply} disabled={disabled}>
          Apply filter
        </button>
        <button type="button" className="btn cus-primary-transparent-btn" onClick={onClear} disabled={disabled}>
          Clear filter
        </button>
      </div>
    </div>
  );
};

PnLFilters.propTypes = {
  filters: PropTypes.shape({
    year: PropTypes.number.isRequired,
    fromMonth: PropTypes.number.isRequired,
    toMonth: PropTypes.number.isRequired,
    categories: PropTypes.arrayOf(PropTypes.string).isRequired,
    subTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  categoryOptions: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
  ).isRequired,
  typeOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default PnLFilters;
